import axiosInstance from '../lib/axios';
import type { SubmitAccessRequestPayload } from '../types/accessRequest.types';

export const accessRequestService = {
  submitRequest: (documentId: string, payload: SubmitAccessRequestPayload) =>
    axiosInstance.post(`/documents/${documentId}/access-request`, payload),

  getAccessStatus: (params: {
    status?: 'Pending' | 'Approved' | 'Denied';
    page?: number;
    limit?: number;
  }) => axiosInstance.get('/access-status', { params }),

  getPendingRequests: (params: { page?: number; limit?: number }) =>
    axiosInstance.get('/access-requests/pending', { params }),

  decideRequest: (
    requestId: string,
    payload: { decision: 'Approved' | 'Denied'; decision_reason: string }
  ) => axiosInstance.post(`/access-requests/${requestId}/decide`, payload),

  /**
   * Get confidential documents the current user does not have approved access to.
   * If backend returns 404 (endpoint not implemented), the page falls back to
   * case search with classification=Confidential and merges with access-status.
   */
  getConfidentialDocuments: (params: { page?: number; limit?: number }) =>
    axiosInstance.get('/documents/confidential-no-access', { params }),
};

export default accessRequestService;
